import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "createStaffView__content" }
const _hoisted_2 = { class: "createStaffView__section" }
const _hoisted_3 = { class: "createStaffView__section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "label-with-required" }, "员工额度", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer createStaffView__wrap" }, {
    title: _withCtx(() => [
      _createVNode(_component_router_link, {
        class: "link-goback",
        to: {name: 'main.staff.list'}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_icon, { type: "arrow-left" })
        ]),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_steps, {
        class: "createStaffView__steps",
        current: _ctx.step
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_step, { title: "填写基本信息" }),
          _createVNode(_component_a_step, { title: "选择支付配置" })
        ]),
        _: 1
      }, 8, ["current"]),
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("section", _hoisted_2, [
          _createVNode(_component_a_form, {
            ref: "basicFormRef",
            class: "createStaffView__form",
            model: _ctx.basicFormData,
            "label-col": _ctx.labelCol,
            "wrapper-col": _ctx.wrapperCol,
            rules: _ctx.basicInfoRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                label: "姓名",
                name: "userName",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.basicFormData.userName,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.basicFormData.userName) = $event)),
                    "allow-clear": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "手机号码",
                name: "phone",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.basicFormData.phone,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.basicFormData.phone) = $event)),
                    type: "number",
                    "allow-clear": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "工号" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.basicFormData.jobNumber,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.basicFormData.jobNumber) = $event)),
                    "allow-clear": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "部门" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tree_select, {
                    value: _ctx.basicFormData.departmentId,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.basicFormData.departmentId) = $event)),
                    style: {"width":"100%"},
                    "allow-clear": "",
                    "show-line": true,
                    "tree-data": _ctx.departmentTree,
                    "search-placeholder": "请选择"
                  }, null, 8, ["value", "tree-data"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "角色",
                name: "roleId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.basicFormData.roleId,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.basicFormData.roleId) = $event)),
                    mode: "multiple",
                    style: {"width":"100%"},
                    placeholder: "请选择角色"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleList, (item) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: item.roleId,
                          value: item.roleId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.roleName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              false
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 0,
                    label: "绑定车辆"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.basicFormData.vehicleId,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.basicFormData.vehicleId) = $event)),
                        mode: "multiple",
                        style: {"width":"100%"},
                        placeholder: "请选择车辆"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoList, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.licensePlate), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 5 } }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    disabled: _ctx.submiting,
                    loading: _ctx.submiting,
                    onClick: _ctx.gotoNextStepOrSubmit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("下一步")
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "label-col", "wrapper-col", "rules"])
        ], 512), [
          [_vShow, _ctx.step === 0]
        ]),
        _withDirectives(_createElementVNode("section", _hoisted_3, [
          _createVNode(_component_a_form, {
            ref: "payFormRef",
            class: "createStaffView__form",
            model: _ctx.payFormData,
            "label-col": _ctx.labelCol,
            "wrapper-col": _ctx.wrapperCol,
            rules: _ctx.payInfoRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "员工" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.basicFormData.userName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "企业支付",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_switch, {
                    checked: _ctx.payFormData.enterprisePay,
                    "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payFormData.enterprisePay) = $event))
                  }, null, 8, ["checked"])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_a_form_item, { name: "finiteAmount" }, {
                label: _withCtx(() => [
                  _hoisted_4
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.payFormData.restrictState,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payFormData.restrictState) = $event)),
                    options: _ctx.restrictStateOptions
                  }, null, 8, ["value", "options"]),
                  _withDirectives(_createElementVNode("span", null, [
                    _createTextVNode(" 每月："),
                    _createVNode(_component_a_input, {
                      value: _ctx.payFormData.finiteAmount,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payFormData.finiteAmount) = $event)),
                      type: "number",
                      placeholder: "请输入整数金额",
                      suffix: "元",
                      style: {"width":"170px"}
                    }, null, 8, ["value"])
                  ], 512), [
                    [_vShow, _ctx.payFormData.restrictState === 'FINITE']
                  ])
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.payFormData.enterprisePay]
              ]),
              _withDirectives(_createVNode(_component_a_form_item, { label: "加油制度" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.payFormData.ruleId,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payFormData.ruleId) = $event)),
                    placeholder: "请选择用户制度",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("无制度")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sceneList, (item) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: item.id,
                          value: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.ruleName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.payFormData.enterprisePay]
              ]),
              _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 5 } }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    disabled: _ctx.submiting,
                    loading: _ctx.submiting,
                    style: {"margin-right":"10px"},
                    onClick: _ctx.onSubmit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存")
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading", "onClick"]),
                  _createVNode(_component_a_button, {
                    type: "default",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.gotoNextStep(-1)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("上一步")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "label-col", "wrapper-col", "rules"])
        ], 512), [
          [_vShow, _ctx.step === 1]
        ])
      ])
    ]),
    _: 1
  }))
}